import { render, staticRenderFns } from "./VideoWrapper.vue?vue&type=template&id=8e866574&lang=pug&"
import script from "./VideoWrapper.vue?vue&type=script&lang=js&"
export * from "./VideoWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports